import service from '@/utils/request'

// 合同列表分页查询
export const page = (params: any) =>
  service.request({
    method: 'post',
    url: '/companyBusinessContract/page',
    data: params
  })

// 新增合同（合同编号系统生成，录入后不可修改）
export const save = (params: any) =>
  service.request({
    method: 'post',
    url: '/companyBusinessContract/save',
    data: params
  })

// 关闭合同（作废，status 置 0）
export const close = (params: any) =>
  service.request({
    method: 'post',
    url: '/companyBusinessContract/close',
    data: params
  })
